const alwaysZero = () => 0;


export default alwaysZero;
